// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 7123 ? "526adfa3" : chunkId) + "." + {"184":"e810394702c35a6c","1061":"93089a5f95205e7e","6735":"a3eb23c166e5ee5a","7119":"a644b02fbf567d3f","7123":"fea82bf5e817a231","7777":"dfe0060e5a23fc25"}[chunkId] + ".js";
};